import type {
  PurchaseOrderType,
  ProductType,
  PurchaseWebCampaignOffer,
} from '@xing-com/crate-common-graphql-types';
import type { RefinedPremiumContacts } from '@xing-com/crate-upsell-types';
import type { ContractPrice } from '@xing-com/crate-upsell-utils';

import { PurchaseStickyBarBase } from './purchase-sticky-bar-base';

export type PurchaseStickyBarProps = Pick<
  PurchaseWebCampaignOffer,
  'contracts'
> & {
  id: string;
  disabled: boolean;
  orderType: PurchaseOrderType;
  duration: number;
  price: ContractPrice;
  product: ProductType;
  isBestSeller: boolean;
  toggleContract: (id: string) => void;
  showFacepile: boolean | undefined;
  premiumContacts: RefinedPremiumContacts | undefined;
};

export function PurchaseStickyBar(props: PurchaseStickyBarProps): JSX.Element {
  return <PurchaseStickyBarBase {...props} />;
}
